
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, Suspense } from "react";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import ChildProfileDetails from "@/pages/ChildProfileDetails";
import TestingModules from "@/pages/TestingModules";
import Test from "@/pages/Test";
import GettingStarted from "@/pages/GettingStarted";
import GoalsAndOutcomes from "@/pages/GoalsAndOutcomes";
import Journal from "@/pages/Journal";
import Notifications from "@/pages/Notifications";
import ContactUs from "@/pages/ContactUs";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import LegalInformation from "@/pages/LegalInformation";
import Paywall from "@/pages/Paywall";
import ResetPassword from "@/pages/ResetPassword";
import { SubscriptionCheck } from "@/components/auth/SubscriptionCheck";
import { scrollToTop } from "@/utils/scrollUtils";

// ScrollToTop component to handle scroll restoration on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  
  return null;
};

// Fallback loading component for suspense
const PageLoading = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
  </div>
);

export const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/legal-information" element={<LegalInformation />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/paywall" element={<Paywall />} />

        {/* Protected Routes (Require Subscription) */}
        <Route path="/dashboard" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <Dashboard />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/child/:id" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <ChildProfileDetails />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/testing-modules" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <TestingModules />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/test/:testId" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <Test />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/getting-started" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <GettingStarted />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/activities-and-goals" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <GoalsAndOutcomes />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/journal" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <Journal />
            </SubscriptionCheck>
          </Suspense>
        } />
        <Route path="/notifications" element={
          <Suspense fallback={<PageLoading />}>
            <SubscriptionCheck>
              <Notifications />
            </SubscriptionCheck>
          </Suspense>
        } />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};
